<template>
  <div class="w-100 mb-5">
    <h3 class="font32 fw700 gray900 mb-4">Mood Chart</h3>
    <!-- <a-month-picker :allowClear="true" :size="'large'" v-model="selectedDate" :disabled-date="tempValue => tempValue >= new Date()" class="other-prof-dovedaily-calendar br8 py-2 px-3" /> -->
    <DatePicker
      v-model="selectedDate"
      type="month"
      class="dovedaily-new-datepicker left-cal-icon"
      :append-to-body="false"
      :disabled-date="tempValue => tempValue >= new Date()"
      placeholder="Select month"
      :clearable="false"
      format="MMM YYYY"
    />
    <div class="moodBox d-flex gap8 align-items-end mt-3" :style="{ height: '232px' }" v-if="overallMood && overallMood.val">
      <div class="br8 p-3 bg-gray100 d-flex flex-column text-center mr18 h-100 justify-content-center" :style="{ width: '186px' }">
        <img src="../../../../assets/emojis/happy-80.png" alt="emoji" class="hw80 ar1 mb-3 mx-auto" />
        <p class="gray700 font18 lh27">Overall mood</p>
        <h5 class="fw700 font20 gray700 lh30">{{ overallMood.name }}</h5>
      </div>
      <div
        class="br8 d-flex flex-column text-center font12 fw700 gray500 text-capitalize justify-content-end gap4"
        v-for="mood in moodData"
        :key="mood.name"
        :style="{ background: getMoodColor(mood.name), height: `${(mood.value / maxMoodVal) * 100}%`, width: '142px', 'min-height': '30%' }"
      >
        <img :src="require(`../../../../assets/emojis/${mood.name}-32.png`)" :alt="mood.name" class="hw24 mx-auto mb-0" />
        {{ mood.name }} <br />
        {{ mood.value }}
      </div>
    </div>
    <div v-else class="p-4 text-center br8 bg-gray100 mt-3">
      <h5 class="font20 fw700 gray900">No mood added yet</h5>
      <p class="mt-2 mb-0 font14 gray700">This user has not added any mood yet.</p>
    </div>

    <h3 class="fw700 font32 gray900 mt80 mb-2">Medication</h3>
    <template v-if="medications && medications.length">
      <div class="eachBox bs br8 mt-3" v-for="medication in medications" :key="medication.id">
        <div class="d-flex align-items-center">
          <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
          <p class="ml-1 mb-0 font16 fw700 newColor">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </p>
          <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
          <!-- <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
        <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" /> -->
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
          <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
            <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
              <p class="mr-3 mb-0 gray900 font12">
                {{ sideEffect.display_name }}
              </p>
              <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                {{ getSideEffectLevel(sideEffect.effectiveness) }}
              </p>
            </div>
          </div>
          <template v-else>
            <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
          </template>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">
            Effectiveness:
            <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
              {{ getEffectLevel(medication.effectiveness) }}
            </span>
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
          <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Doing" }}</p>
          <!-- <p class="mb-0 font12 fw700 red300 ml-auto" v-if="!medication.treatment_duration[0][1]">Stopped</p> -->
        </div>
      </div>
    </template>
    <div v-else class="p-4 text-center br8 bg-gray100">
      <h5 class="font20 fw700 gray900">No medication added yet</h5>
      <p class="mt-2 mb-0 font14 gray700">This user has not added any medication yet.</p>
    </div>

    <h3 class="fw700 font32 gray900 mt80 mb-2">Activities</h3>
    <template v-if="activities && activities.length">
      <div class="eachBox bs br8 mt-3" v-for="medication in activities" :key="medication.id">
        <div class="d-flex align-items-center">
          <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
          <p class="ml-1 mb-0 font16 fw700 newColor">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </p>
          <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
          <!-- <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
        <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" /> -->
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
          <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
            <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
              <p class="mr-3 mb-0 gray900 font12">
                {{ sideEffect.display_name }}
              </p>
              <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                {{ getSideEffectLevel(sideEffect.effectiveness) }}
              </p>
            </div>
          </div>
          <template v-else>
            <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
          </template>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">
            Effectiveness:
            <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
              {{ getEffectLevel(medication.effectiveness) }}
            </span>
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
          <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Doing" }}</p>
          <!-- <p class="mb-0 font12 fw700 red300 ml-auto" v-if="!medication.treatment_duration[0][1]">Stopped</p> -->
        </div>
      </div>
    </template>
    <div v-else class="p-4 text-center br8 bg-gray100">
      <h5 class="font20 fw700 gray900">No activities added yet</h5>
      <p class="mt-2 mb-0 font14 gray700">This user has not added any activities yet.</p>
    </div>

    <h3 class="fw700 font32 gray900 mt80 mb-2">Procedures</h3>
    <template v-if="procedures && procedures.length">
      <div class="eachBox bs br8 mt-3" v-for="medication in procedures" :key="medication.id">
        <div class="d-flex align-items-center">
          <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
          <p class="ml-1 mb-0 font16 fw700 newColor">
            {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
          </p>
          <!-- <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1 ml-2">Fully Taken</div> -->
          <!-- <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp ml-auto" :style="{ color: getPrimary300Color() }" />
        <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" /> -->
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
          <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
            <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
              <p class="mr-3 mb-0 gray900 font12">
                {{ sideEffect.display_name }}
              </p>
              <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">
                {{ getSideEffectLevel(sideEffect.effectiveness) }}
              </p>
            </div>
          </div>
          <template v-else>
            <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div>
          </template>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">
            Effectiveness:
            <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
              {{ getEffectLevel(medication.effectiveness) }}
            </span>
          </p>
        </div>
        <div class="d-flex align-items-center mt-3">
          <p class="mb-0 font12 gray900">From: {{ new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}</p>
          <p class="mb-0 font12 gray900 ml-3">To: {{ medication.treatment_duration[0][1] ? new Date(medication.treatment_duration[0][1]).toDateString().substring(4) : "Still Doing" }}</p>
          <!-- <p class="mb-0 font12 fw700 red300 ml-auto" v-if="!medication.treatment_duration[0][1]">Stopped</p> -->
        </div>
      </div>
    </template>
    <div v-else class="p-4 text-center br8 bg-gray100">
      <h5 class="font20 fw700 gray900">No procedures added yet</h5>
      <p class="mt-2 mb-0 font14 gray700">This user has not added any procedures yet.</p>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientDoveDaily",
  components: { DatePicker },
  async created() {
    // console.log("this.viewUser:", this.viewUser)
    this.selectedDate = this.moment()

    const medResponse = await UserRepository.getTreatments({ id: this.viewUser.id, role: this.viewUser.role }, this.currentCircle.id, "Medication", 1, 1)
    this.medications = medResponse.data.data || []

    const activityResponse = await UserRepository.getTreatments({ id: this.viewUser.id, role: this.viewUser.role }, this.currentCircle.id, "Activity", 1, 1)
    this.activities = activityResponse.data.data || []

    const proceduresResponse = await UserRepository.getTreatments({ id: this.viewUser.id, role: this.viewUser.role }, this.currentCircle.id, "Procedure")
    this.procedures = proceduresResponse.data.data

    // const nutritionResponse = await UserRepository.getTreatments({ id: this.viewUser.id, role: this.viewUser.role }, this.currentCircle.id, "Nutrition")
    // this.nutritions = nutritionResponse.data.data || []
  },
  data() {
    return {
      selectedDate: null,
      maxMoodVal: 0,
      moodData: [
        // { name: "good", value: 8 },
        // { name: "okay", value: 3 },
        // { name: "bad", value: 5 },
      ],
      overallMood: { name: "", val: 0 },
      // medications: [
      //   {
      //     id: 0,
      //     effectiveness: 0,
      //     treatment_duration: [["2022-1-1", "2014-4-4"]],
      //     side_effect: [
      //       { display_name: "Headache", effectiveness: 100 },
      //       { display_name: "Nausea", effectiveness: 100 },
      //     ],
      //     treatment: [{ display_name: "Tylenol" }],
      //   },
      //   {
      //     id: 1,
      //     effectiveness: 50,
      //     treatment_duration: [["2022-1-1"]],
      //     side_effect: [
      //       { display_name: "Headache", effectiveness: 0 },
      //       { display_name: "Nausea", effectiveness: 100 },
      //     ],
      //     treatment: [{ display_name: "Something" }],
      //   },
      //   {
      //     id: 2,
      //     effectiveness: 100,
      //     treatment_duration: [["2022-1-1", null]],
      //     side_effect: [
      //       { display_name: "Headache", effectiveness: 100 },
      //       { display_name: "Nausea", effectiveness: 50 },
      //     ],
      //     treatment: [{ display_name: "Medic" }],
      //   },
      // ],
      medications: [],
      nutritions: [],
      activities: [],
    }
  },
  watch: {
    selectedDate: {
      async handler(v) {
        if (v) {
          this.resetVals()
          const ALL_MOODS = { good: false, bad: false, okay: false }
          const response = await UserRepository.getOthersProfDovedaily(this.currentCircle.id, this.viewUser.id, new Date(v).getFullYear(), new Date(v).getMonth() + 1)
          // console.log("res:", response)
          // console.log("res.data:", response.data)
          if (response.data.greater_count) {
            this.overallMood.name = response.data.greater_count.mood
            this.overallMood.val = response.data.greater_count.count
          }
          if (response.data.mood_counts && response.data.mood_counts.length) {
            this.moodData = response.data.mood_counts.map(mood => {
              if (this.maxMoodVal < mood.count) {
                this.maxMoodVal = mood.count
              }
              ALL_MOODS[mood.mood] = true
              return { name: mood.mood, value: mood.count }
            })
          }
          Object.entries(ALL_MOODS).forEach(mood => {
            if (!mood[1]) {
              this.moodData.push({ name: mood[0], value: 0 })
            }
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetVals() {
      this.maxMoodVal = 0
      this.moodData = []
      this.overallMood = { name: "Not Added", val: 0 }
    },
    getMoodColor(mood) {
      switch (mood) {
        case "good":
          return "#B3EDDB"
        case "okay":
          return "#FFF0D6"
        case "bad":
          return "#FFD7B3"
        default:
          return "#FFF"
      }
    },
    getSideEffectColor(e) {
      switch (e) {
        case 0:
        case "0":
          return "success500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "error500"
      }
    },
    getEffectColor(e) {
      switch (e) {
        case null:
          return "gray400"
        case 0:
        case "0":
          return "error500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "success500"
      }
    },
    getEffectLevel(e) {
      switch (e) {
        case null:
          return "Not specified"
        case 0:
        case "0":
          return "Not effective"
        case 50:
        case "50":
          return "Somewhat effective"
        case 100:
        case "100":
          return "Very effective"
      }
    },
    getSideEffectLevel(e) {
      switch (e) {
        case 0:
        case "0":
          return "Mild"
        case 50:
        case "50":
          return "Moderate"
        case 100:
        case "100":
          return "Severe"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
p,
h4,
h5 {
  margin-bottom: 0 !important;
}
.eachBox {
  border: 1px solid #e2e8f0;
  padding: 12px;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  transform: translateY(1px);
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientDoveDaily.vue